var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"data-cy":"third-parties"}},_vm._l((_vm.thirdPartiesInfo),function(info){return _c('RowThirdParty',{key:info.id,attrs:{"third-party-informations":info},on:{"third-party-id-to-display":_vm.handleThirdPartyIdToDisplay}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }